import { render, staticRenderFns } from "./IssueTracker.vue?vue&type=template&id=0948da16&scoped=true&"
import script from "./IssueTracker.vue?vue&type=script&lang=js&"
export * from "./IssueTracker.vue?vue&type=script&lang=js&"
import style0 from "./IssueTracker.vue?vue&type=style&index=0&id=0948da16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0948da16",
  null
  
)

export default component.exports